import { render, staticRenderFns } from "./SideNavigationGroup.vue?vue&type=template&id=fa8db0fc&"
import script from "./SideNavigationGroup.vue?vue&type=script&lang=ts&"
export * from "./SideNavigationGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa8db0fc')) {
      api.createRecord('fa8db0fc', component.options)
    } else {
      api.reload('fa8db0fc', component.options)
    }
    module.hot.accept("./SideNavigationGroup.vue?vue&type=template&id=fa8db0fc&", function () {
      api.rerender('fa8db0fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/navigation/side/SideNavigationGroup.vue"
export default component.exports